import React from 'react'
import { useStatistics } from './context'
import { PerformanceAreaChart } from './AreaChart'
import { PerformanceBarChart } from './BarChart'
import { varClass } from '../../shared'

export const Graph = (props) => {
  const { isSingleDate } = props
  const { data, group, graphColumns, setGraphHeight } = useStatistics()

  return (
    <div className="relative">
      <div className="graph-container">
        {group === 'date' ? (
          <PerformanceAreaChart
            rows={data.rows}
            {...{
              graphColumns,
              setGraphHeight,
              isSingleDate,
            }}
          />
        ) : (
          <PerformanceBarChart
            rows={data.rows}
            {...{
              graphColumns,
              setGraphHeight,
            }}
          />
        )}
      </div>
    </div>
  )
}

export const GraphSwitch = (props) => {
  const { title, value, selectedValues, setValues, color } = props

  const isGraphColumnShown = selectedValues.indexOf(value) !== -1

  return (
    <button
      className={varClass({
        'btn btn-sm m-r-15': true,
        'active': isGraphColumnShown,
      })}
      style={
        isGraphColumnShown
          ? {
              color: color,
              background: color + '1A',
            }
          : {}
      }
      onClick={() => {
        const newValues = [...selectedValues]
        if (isGraphColumnShown) {
          newValues.splice(newValues.indexOf(value), 1)
        } else {
          newValues.push(value)
        }
        setValues(newValues)
      }}
    >
      {title}
    </button>
  )
}
